import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api  from '@/shared/api/api';
import { AdminLayout } from '@/components/Layout/Layout';
import ProjectForm from './forms/ProjectForm';
import { useFetch } from '@/shared/hooks/useFetch';
import { ProjectResponseDTO, ProjectUpdateDTO } from '@/shared/api/gen/data-contracts';
// import EmployeeForm from '../fonds/EmployeeForm';


function ProjectUpdate() {
    const navigate = useNavigate();
    const {projectID} = useParams();
    const {data} = useFetch(()=>api.projects.getProjectsDetailApiProjectsIdGet(Number(projectID)), {} as unknown as ProjectResponseDTO, [])
    const onSubmit = (data: ProjectUpdateDTO) => {
        api.projects.updateProjectsApiProjectsIdPut(
            Number(projectID),
            data
        )
    }
    return (
        <AdminLayout>
            <div className='FormRow'>
                <div onClick={() => navigate(-1)}>Назад</div>
                <h1 className='text-30'>Изменение данных проекта</h1>
            </div>
            <ProjectForm defaultData={{...data}} onSubmit={onSubmit} />
        </AdminLayout>
    )
}

export default ProjectUpdate;